import { useState } from "react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export function ResetPasswordForm({
  userId,
  secret,
  onDone,
  onError,
}: {
  userId: string;
  secret: string;
  onDone: () => void;
  onError: (message: string) => void;
}) {
  const [newPassword, setNew] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const valid = newPassword.length >= 8 && newPassword === confirm;

  async function submit() {
    setBusy(true);
    try {
      const res = await fetch(
        `${import.meta.env.VITE_API_URL ?? "/api"}/auth/reset-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ userId, secret, newPassword }),
        },
      );
      const body = await res.json().catch(() => ({}));
      if (!res.ok) {
        onError(body.error === "password_reused" ? "Cannot reuse a recent password." : body.error === "locked" ? "Locked. Try later." : "Reset failed.");
        return;
      }
      onDone();
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="space-y-4" aria-live="polite">
      <div>
        <h2 className="font-serif text-xl text-maroon-700">New password</h2>
        <p className="text-sm text-ink-500">Set a new password for your account.</p>
      </div>
      <div>
        <Label htmlFor="rp-new">New password</Label>
        <Input
          id="rp-new"
          type="password"
          value={newPassword}
          onChange={(e) => setNew(e.target.value)}
          autoComplete="new-password"
          autoFocus
        />
      </div>
      <div>
        <Label htmlFor="rp-confirm">Confirm</Label>
        <Input
          id="rp-confirm"
          type="password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          autoComplete="new-password"
        />
      </div>
      <Button onClick={submit} disabled={!valid || busy} className="w-full">
        {busy ? "Saving…" : "Reset password"}
      </Button>
    </div>
  );
}
